import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import frCommon from '@/locales/fr/common.json';
import frAuth from '@/locales/fr/auth.json';
import frNavigation from '@/locales/fr/navigation.json';
import frErrors from '@/locales/fr/errors.json';
import frProducts from '@/locales/fr/products.json';
import frStock from '@/locales/fr/stock.json';
import frCategories from '@/locales/fr/categories.json';
import frBrands from '@/locales/fr/brands.json';
import frSuppliers from '@/locales/fr/suppliers.json';
import frSales from '@/locales/fr/sales.json';
import frCustomers from '@/locales/fr/customers.json';
import frEmployees from '@/locales/fr/employees.json';
import frDashboard from '@/locales/fr/dashboard.json';
import frAdmin from '@/locales/fr/admin.json';
import frBilling from '@/locales/fr/billing.json';
import frOnboarding from '@/locales/fr/onboarding.json';
import frSettings from '@/locales/fr/settings.json';
import frAttributes from '@/locales/fr/attributes.json';
import frMarketing from '@/locales/fr/marketing.json';
import frPos from '@/locales/fr/pos.json';
import frReports from '@/locales/fr/reports.json';
import frGuide from '@/locales/fr/guide.json';
import frConsent from '@/locales/fr/consent.json';
import frDevices from '@/locales/fr/devices.json';
import enCommon from '@/locales/en/common.json';
import enAuth from '@/locales/en/auth.json';
import enNavigation from '@/locales/en/navigation.json';
import enErrors from '@/locales/en/errors.json';
import enProducts from '@/locales/en/products.json';
import enStock from '@/locales/en/stock.json';
import enCategories from '@/locales/en/categories.json';
import enBrands from '@/locales/en/brands.json';
import enSuppliers from '@/locales/en/suppliers.json';
import enSales from '@/locales/en/sales.json';
import enCustomers from '@/locales/en/customers.json';
import enEmployees from '@/locales/en/employees.json';
import enDashboard from '@/locales/en/dashboard.json';
import enAdmin from '@/locales/en/admin.json';
import enBilling from '@/locales/en/billing.json';
import enOnboarding from '@/locales/en/onboarding.json';
import enSettings from '@/locales/en/settings.json';
import enAttributes from '@/locales/en/attributes.json';
import enMarketing from '@/locales/en/marketing.json';
import enPos from '@/locales/en/pos.json';
import enReports from '@/locales/en/reports.json';
import enGuide from '@/locales/en/guide.json';
import enConsent from '@/locales/en/consent.json';
import enDevices from '@/locales/en/devices.json';
import frPromotions from '@/locales/fr/promotions.json';
import enPromotions from '@/locales/en/promotions.json';
import frBar from '@/locales/fr/bar.json';
import enBar from '@/locales/en/bar.json';
import frTour from '@/locales/fr/tour.json';
import enTour from '@/locales/en/tour.json';
import frCommerce from '@/locales/fr/commerce.json';
import enCommerce from '@/locales/en/commerce.json';
import frStorefront from '@/locales/fr/storefront.json';
import enStorefront from '@/locales/en/storefront.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        common: frCommon,
        auth: frAuth,
        navigation: frNavigation,
        errors: frErrors,
        products: frProducts,
        stock: frStock,
        categories: frCategories,
        brands: frBrands,
        suppliers: frSuppliers,
        sales: frSales,
        customers: frCustomers,
        employees: frEmployees,
        dashboard: frDashboard,
        admin: frAdmin,
        billing: frBilling,
        onboarding: frOnboarding,
        settings: frSettings,
        attributes: frAttributes,
        marketing: frMarketing,
        pos: frPos,
        reports: frReports,
        guide: frGuide,
        consent: frConsent,
        devices: frDevices,
        promotions: frPromotions,
        bar: frBar,
        tour: frTour,
        commerce: frCommerce,
        storefront: frStorefront,
      },
      en: {
        common: enCommon,
        auth: enAuth,
        navigation: enNavigation,
        errors: enErrors,
        products: enProducts,
        stock: enStock,
        categories: enCategories,
        brands: enBrands,
        suppliers: enSuppliers,
        sales: enSales,
        customers: enCustomers,
        employees: enEmployees,
        dashboard: enDashboard,
        admin: enAdmin,
        billing: enBilling,
        onboarding: enOnboarding,
        settings: enSettings,
        attributes: enAttributes,
        marketing: enMarketing,
        pos: enPos,
        reports: enReports,
        guide: enGuide,
        consent: enConsent,
        devices: enDevices,
        promotions: enPromotions,
        bar: enBar,
        tour: enTour,
        commerce: enCommerce,
        storefront: enStorefront,
      },
    },
    defaultNS: 'common',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
